export function amOrPm(hora) {
  var strAmPm = "";
  var horas = parseInt(hora.split(":")[0]);
  if (horas < 12) {
    strAmPm = " AM";
  } else {
    strAmPm = "PM";
  }
  return strAmPm;
}
